import { useI18n } from '@/providers/i18n';
import type { Language } from '@/types';

import styles from './LangSwitcher.module.css';

const LANGUAGES: Language[] = ['en', 'hy', 'ru'];
const LABELS: Record<Language, string> = { en: 'EN', hy: 'ՀՅ', ru: 'РУ' };

export default function LangSwitcher() {
  const { lang, setLang } = useI18n();
  return (
    <div className={styles.root}>
      {LANGUAGES.map((l) => (
        <button
          key={l}
          type="button"
          className={`${styles.btn} ${lang === l ? styles.active : ''}`}
          onClick={() => setLang(l)}
          aria-label={`Switch to ${l.toUpperCase()}`}
        >
          {LABELS[l]}
        </button>
      ))}
    </div>
  );
}
